module.exports = __webpack_public_path__ + "img/title.ab1768de.png";